import { environment } from "../../../environments/environment";

const appConfig = {
  baseUrl: environment.baseUrl,
  myAccountBaseUrl: environment.myAccountBaseUrl,
  analyticsBaseUrl: environment.analyticsBaseUrl,
  myJobsUrl: environment.myJobsUrl,
  vettimesUrl: environment.vettimesUrl,
  CPDUrl: 'https://cpd.vettimes.co.uk/',
  vettimesDomain: 'vettimes.com',
  subDomain: environment.subDomain,
  allJobsUrl: 'https://jobs.vettimes.co.uk/?_gl=1*noj4m4*_gcl_au*MTQwNDU5MDA4NS4xNzM0NjE2Nzk0*_ga*ODIwNTQyMTM1LjE3MzQ2MTY3OTQ.*_ga_3TYFJGLYL7*MTczNTcyNjc4MC4xNi4xLjE3MzU3MjgwNzkuNjAuMC4w',
  recruitersUrl: "https://recruitment.vettimes.co.uk/",
  rcvsUrl: 'https://findavet.rcvs.org.uk/find-a-vet-surgeon/',
  footerCopyright: `© Veterinary Business Development Ltd ${new Date().getFullYear()}`,
  googleAnalyticsKey: 'SSO-V3'
};

export default appConfig;
